module.exports = __webpack_public_path__ + "static/media/Inside_Affiliate.3a1665ec.pdf";